import comp from "./QuestionCard";
export default comp;
